// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"_3-L4p","header":"Vlm-F","logo":"fKo8o"};